import { cn } from '@/lib/utils'
import { type TourHighlightProps, tourHighlightVariants } from './tour-variants'

export function TourHighlight({ children, variant, className }: TourHighlightProps) {
  return <p className={cn(tourHighlightVariants({ variant }), className)}>{children}</p>
}
